import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar"; 
import Header from "./Header";

const Layout: React.FC = () => {
  // This state is for the mobile slide-out menu
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // This state is for the desktop collapsible menu (w-64 vs w-20)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        isCollapsed={isSidebarCollapsed} // Passed for shrinking visuals
        onToggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)} // Passed for the button inside
      />

      <div
        // CRITICAL FIX: Dynamic padding pushes main content away from the sidebar.
        className={`main-content transition-all duration-300 ease-in-out ${
          isSidebarCollapsed ? "lg:pl-20" : "lg:pl-64"
        }`}
      >
        <Header 
          onMenuClick={() => setSidebarOpen(!sidebarOpen)} 
          // Header no longer needs toggle control, but still needs mobile function
        />

        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
